import { useQuery } from '@tanstack/react-query';
import { getItemByLetter, getItemDetail, getSearchItem } from 'lib/api/glossary';
import { GLOSSARY_QUERY_KEY, STALE_TIME } from './constants';

import { APIResponse } from '../../../@types/api-response.d';

const useGlossaryQuery = (
  key: string,
  queryKey: string[],
  queryFunc: (keyValue: string) => Promise<APIResponse>,
) =>
  useQuery({
    queryKey,
    queryFn: async () => {
      try {
        const { data } = await queryFunc(key);
        return data.data || [];
      } catch (error) {
        throw new Error(`Failed to get glossary ${key}: ${error}`);
      }
    },
    staleTime: STALE_TIME,
    enabled: !!key,
    retry: (count) => count < 10,
    onError: () => {
      throw new Error(`Attempt to get glossary ${key} Failed`);
    },
  });

export const useGlossaries = (letter: string) => {
  const queryKey = [GLOSSARY_QUERY_KEY.TERMS, letter];
  return useGlossaryQuery(letter, queryKey, getItemByLetter);
};

export const useGlossary = (slug: string) => {
  const queryKey = [GLOSSARY_QUERY_KEY.TERM, slug];
  return useGlossaryQuery(slug, queryKey, getItemDetail);
};

export const useGlossarySearch = (searchTerm: string) => {
  const queryKey = [GLOSSARY_QUERY_KEY.SEARCH, searchTerm];
  return useGlossaryQuery(searchTerm, queryKey, getSearchItem);
}
